import type { Playbook } from '@squadlab/contracts';
import { ONBOARDING_PLAYBOOK } from './onboarding.js';
import { LEAVE_PLAYBOOK } from './leave.js';
import { DOC_RENEWAL_PLAYBOOK } from './doc-renewal.js';
import { LETTER_PLAYBOOK } from './letter.js';

export { ONBOARDING_PLAYBOOK, LEAVE_PLAYBOOK, DOC_RENEWAL_PLAYBOOK, LETTER_PLAYBOOK };

/** The four v1 playbooks (operator-started and watchdog-started) — ADR 0052. */
export const PLAYBOOKS: readonly Playbook[] = [
  ONBOARDING_PLAYBOOK,
  LEAVE_PLAYBOOK,
  DOC_RENEWAL_PLAYBOOK,
  LETTER_PLAYBOOK,
];
